export default __webpack_public_path__ + "assets/salon-style-epure-moderne-quebec.1df5e50c.webp";